module.exports = __webpack_public_path__ + "1cbc855eaad29c158ababd6971a2b642.gif";